export enum CalendarPageViewEvents {
  viewSchedulePage = 'View Schedule Page',
  viewGroupsPage = 'View Groups Page',
  viewAvailabilityPage = 'View Availability Page',
  viewIntegrationPage = 'View Integration Page',
}

export const calendarPageTitles: Record<string, string> = {
  availability: CalendarPageViewEvents.viewAvailabilityPage,
  groups: CalendarPageViewEvents.viewGroupsPage,
  integration: CalendarPageViewEvents.viewIntegrationPage,
  schedule: CalendarPageViewEvents.viewSchedulePage,
};

export const getCalendarPageTitle = (page: string): string | undefined => {
  const regex = /^\/maud\/calendar\/([^/]+)/;
  const match = page.match(regex);

  if (match) {
    const token = match[1] ?? 'schedule';
    return calendarPageTitles[token];
  }

  return undefined;
};
